import { createRpcClientV2 } from 'rpc-client-utils';
import { listByPathRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ThemePresetRpc';
import { createRpc, updateRpc, deleteRpc, getByThemePathAndBusinessUnitIdRpc, getBufferRpc, updateBufferRpc, hasBufferedChangesRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ActiveThemePresetRpc';
import { PRESET_TYPES } from '../constants/Presets';
import http from 'hub-http/clients/apiClient';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchPresets = themePath => rpcClient.call(listByPathRpc, {
  request: {
    path: themePath
  }
});
export const fetchActivePreset = themePath => rpcClient.call(getByThemePathAndBusinessUnitIdRpc, {
  request: {
    themePath
  }
});
export const initializeActivePreset = themePath => rpcClient.call(createRpc, {
  request: {
    themePath,
    activeThemePresetType: 'EMPTY'
  }
});
export const fetchActivePresetBuffer = activeThemePresetObjectId => rpcClient.call(getBufferRpc, {
  request: {
    id: activeThemePresetObjectId
  }
});
export const hasBufferedPresetChanges = activeThemePresetObjectId => rpcClient.call(hasBufferedChangesRpc, {
  request: {
    id: activeThemePresetObjectId
  }
});
export const updateActivePresetBuffer = (activeThemePresetObjectId, activeThemePresetId) => {
  return rpcClient.call(updateBufferRpc, {
    request: {
      id: activeThemePresetObjectId,
      activeThemePresetId,
      activeThemePresetType: activeThemePresetId ? PRESET_TYPES.CUSTOM : PRESET_TYPES.EMPTY
    }
  });
};
export const setActivePreset = (themePath, activeThemePresetId, hasActiveThemePreset) => rpcClient.call(hasActiveThemePreset ? updateRpc : createRpc, {
  request: {
    themePath,
    activeThemePresetType: PRESET_TYPES.CUSTOM,
    // hardcode for now
    activeThemePresetId
  }
});
export const clearActivePreset = themePath => rpcClient.call(deleteRpc, {
  request: {
    themePath
  }
});